import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTenantSwitch } from '@kp/react-sdk';
import { Skeleton, TenantSwitcher, createClasses, toaster } from '@kp/react-ui';

import { useQuery } from '@tanstack/react-query';

import { getUserTenants } from '@/api/user';

const classes = createClasses({
  skeleton: {
    width: '240px',
    height: '32px',
    borderRadius: '6px',
  },
});

export const TenantSwitch: React.FC = () => {
  const { t } = useTranslation();
  const { currentTenantId, isSwitching, switchTenant } = useTenantSwitch();

  const { data, isLoading } = useQuery({
    queryKey: ['getUserTenants'],
    queryFn: () => getUserTenants(0, 100),
  });

  const tenants = data?.data ?? [];

  const handleChange = async (tenantId: string) => {
    if (!tenantId || tenantId === currentTenantId) return;
    try {
      await switchTenant(tenantId);
      globalThis.location.href = globalThis.location.pathname;
    } catch (error) {
      toaster.add({
        id: 'tenant-switch-error',
        type: 'error',
        content:
          error instanceof Error ? error.message : t('tenantSwitch.error'),
      });
    }
  };

  if (isLoading || isSwitching) {
    return <Skeleton className={classes.skeleton} />;
  }

  return (
    <TenantSwitcher
      data-testid="tenant-switch"
      data={tenants}
      value={currentTenantId}
      onChange={handleChange}
      placeholder={t('tenantSwitch.placeholder')}
      searchPlaceholder={t('tenantSwitch.searchLabel')}
      emptyText={t('tenantSwitch.emptyText')}
      disabled={isSwitching}
    />
  );
};
